import { computed, inject } from "vue";
import {
  checkRenderElementShowStatus,
  cssTextToJsObjWithBindData,
  filterConfigByScript,
} from "@/utils/renderBinding";

function resolveConfigSource(configSource) {
  return typeof configSource === "function" ? configSource() : configSource;
}

export function useRenderConfig(configSource) {
  const getConfigJson = inject("getConfigJson", () => ({}));
  const getCommonConfigJson = inject("getCommonConfigJson", () => ({}));

  const commonConfig = computed(() => {
    return typeof getCommonConfigJson === "function" ? getCommonConfigJson() : {};
  });

  const pageConfig = computed(() => {
    return typeof getConfigJson === "function" ? getConfigJson() : {};
  });

  const bindData = computed(() => {
    return {
      ...(commonConfig.value?.bindData || {}),
      ...(pageConfig.value?.bindData || {}),
    };
  });

  const filterConfig = computed(() => {
    const currentConfig = resolveConfigSource(configSource) || {};
    if (!currentConfig.filterScript) {
      return currentConfig;
    }
    return filterConfigByScript(
      currentConfig.filterScript,
      bindData.value,
      currentConfig,
    );
  });

  const showStatus = computed(() => {
    if (pageConfig.value?.isPreview || commonConfig.value?.isPreview) {
      return true;
    }
    return checkRenderElementShowStatus(bindData.value, filterConfig.value || {});
  });

  const setStyle = computed(() => {
    return cssTextToJsObjWithBindData(filterConfig.value?.styles || "", bindData.value);
  });

  return {
    bindData,
    filterConfig,
    setStyle,
    showStatus,
  };
}
